import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  IDProps,
  InvoicePayload,
  InvoiceStatusResponse,
  OrderPayload,
  InvoiceWalletPayload,
} from "type/invoice";

export const invoice = createApi({
  reducerPath: "invoice",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAllInvoices: builder.query<any, InvoicePayload>({
      query: ({ page, startDate, endDate, search, paymentStatus }) => {
        const params = new URLSearchParams();
        if (page) params.append("page", page.toString());
        if (search) params.append("search", search);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (paymentStatus) params.append("paymentStatus", paymentStatus);

        return {
          url: `invoices?${params.toString()}`,
          method: "GET",
        };
      },
    }),

    getInvoicesStats: builder.query<any, InvoicePayload>({
      query: ({ page, startDate, endDate, search, paymentStatus }) => {
        const params = new URLSearchParams();
        if (page) params.append("page", page.toString());
        if (search) params.append("search", search);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (paymentStatus) params.append("paymentStatus", paymentStatus);

        return {
          url: `invoices?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getAllInvoiceTransaction: builder.query<any, InvoicePayload>({
      query: ({ page, startDate, endDate, search, paymentStatus }) => {
        const params = new URLSearchParams();
        if (page) params.append("page", page.toString());
        if (search) params.append("search", search);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (paymentStatus) params.append("paymentStatus", paymentStatus);

        return {
          url: `invoices?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getInvoiceTransactionStats: builder.query<any, InvoicePayload>({
      query: ({ page, startDate, endDate, search, paymentStatus }) => {
        const params = new URLSearchParams();
        if (page) params.append("page", page.toString());
        if (search) params.append("search", search);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (paymentStatus) params.append("paymentStatus", paymentStatus);

        return {
          url: `invoices?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getInvoiceByDocNumber: builder.query<any, IDProps>({
      query: ({ id }) => ({
        url: `invoices/${id}`,
        method: "GET",
      }),
    }),
    getInvoicePDF: builder.query<any, IDProps>({
      query: ({ id }) => ({
        url: `invoices/${id}/pdf`,
        method: "GET",
      }),
    }),
    getInvoiceOrders: builder.mutation<any, OrderPayload>({
      query: (body) => ({
        url: `/orders/clusterSearch`,
        method: "POST",
        body,
      }),
    }),
    getInvoiceWalletCheckout: builder.mutation<any, InvoiceWalletPayload>({
      query: (body) => ({
        url: `/wallets/invoice/checkout`,
        method: "POST",
        body,
      }),
    }),
    getTransactionsCount: builder.query<InvoiceStatusResponse, void>({
      query: () => ({
        url: `/invoices/transactions-count`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllInvoicesQuery,
  useGetAllInvoiceTransactionQuery,
  useGetInvoiceByDocNumberQuery,
  useGetInvoicePDFQuery,
  useGetInvoiceOrdersMutation,
  useGetInvoiceWalletCheckoutMutation,
  useGetInvoiceTransactionStatsQuery,
  useGetInvoicesStatsQuery,
  useGetTransactionsCountQuery,
} = invoice;
